import { environment } from '../environments/environment';

export const AgmConfig = {apiKey: environment.agmkey};



// WEBPACK FOOTER //
// /Users/enzo/Desktop/capsycofr-angular/src/app/app.config.ts